import w from "../../@babel/runtime/helpers/esm/defineProperty.mjs";
import Pe from "../../@babel/runtime/helpers/esm/objectWithoutProperties.mjs";
import K from "../../@babel/runtime/helpers/esm/extends.mjs";
import Se from "../../@babel/runtime/helpers/esm/toConsumableArray.mjs";
import Ie from "../../@babel/runtime/helpers/esm/slicedToArray.mjs";
import Y from "../../classnames/index.mjs";
import we from "../../rc-util/es/hooks/useMemo.mjs";
import c from "../../rc-util/es/KeyCode.mjs";
import Ce from "../../rc-util/es/omit.mjs";
import Z from "../../rc-util/es/pickAttrs.mjs";
import Ee from "../../rc-virtual-list/es/List.mjs";
import * as i from "react";
import { useEffect as $ } from "react";
import Oe from "./hooks/useBaseProps.mjs";
import Ae from "./SelectContext.mjs";
import ke from "./TransBtn.mjs";
import { isPlatformMac as Le } from "./utils/platformUtil.mjs";
var Te = ["disabled", "title", "children", "style", "className"];
function ee(C) {
  return typeof C == "string" || typeof C == "number";
}
var Ve = function(_e, te) {
  var u = Oe(), re = u.prefixCls, E = u.id, v = u.open, x = u.multiple, H = u.mode, R = u.searchValue, F = u.toggleOpen, oe = u.notFoundContent, ne = u.onPopupScroll, s = i.useContext(Ae), O = s.flattenOptions, z = s.onActiveValue, ae = s.defaultActiveFirstOption, ie = s.onSelect, h = s.menuItemSelectedIcon, p = s.rawValues, U = s.fieldNames, N = s.virtual, le = s.direction, se = s.listHeight, ce = s.listItemHeight, g = "".concat(re, "-item"), f = we(function() {
    return O;
  }, [v, O], function(t, e) {
    return e[0] && t[1] !== e[1];
  }), P = i.useRef(null), B = function(e) {
    e.preventDefault();
  }, A = function(e) {
    P.current && P.current.scrollTo(typeof e == "number" ? {
      index: e
    } : e);
  }, k = function(e) {
    for (var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, a = f.length, o = 0; o < a; o += 1) {
      var n = (e + o * r + a) % a, l = f[n], m = l.group, V = l.data;
      if (!m && !V.disabled)
        return n;
    }
    return -1;
  }, ue = i.useState(function() {
    return k(0);
  }), W = Ie(ue, 2), d = W[0], fe = W[1], S = function(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    fe(e);
    var a = {
      source: r ? "keyboard" : "mouse"
    }, o = f[e];
    if (!o) {
      z(null, -1, a);
      return;
    }
    z(o.value, e, a);
  };
  $(function() {
    S(ae !== !1 ? k(0) : -1);
  }, [f.length, R]);
  var j = i.useCallback(function(t) {
    return p.has(t) && H !== "combobox";
  }, [H, Se(p).toString(), p.size]);
  $(function() {
    var t = setTimeout(function() {
      if (!x && v && p.size === 1) {
        var r = Array.from(p)[0], a = f.findIndex(function(o) {
          var n = o.data;
          return n.value === r;
        });
        a !== -1 && (S(a), A(a));
      }
    });
    if (v) {
      var e;
      (e = P.current) === null || e === void 0 || e.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(t);
    };
  }, [v, R, O.length]);
  var L = function(e) {
    e !== void 0 && ie(e, {
      selected: !p.has(e)
    }), x || F(!1);
  };
  if (i.useImperativeHandle(te, function() {
    return {
      onKeyDown: function(e) {
        var r = e.which, a = e.ctrlKey;
        switch (r) {
          case c.N:
          case c.P:
          case c.UP:
          case c.DOWN: {
            var o = 0;
            if (r === c.UP ? o = -1 : r === c.DOWN ? o = 1 : Le() && a && (r === c.N ? o = 1 : r === c.P && (o = -1)), o !== 0) {
              var n = k(d + o, o);
              A(n), S(n, !0);
            }
            break;
          }
          case c.ENTER: {
            var l = f[d];
            l && !l.data.disabled ? L(l.value) : L(void 0), v && e.preventDefault();
            break;
          }
          case c.ESC:
            F(!1), v && e.stopPropagation();
        }
      },
      onKeyUp: function() {
      },
      scrollTo: function(e) {
        A(e);
      }
    };
  }), f.length === 0)
    return /* @__PURE__ */ i.createElement("div", {
      role: "listbox",
      id: "".concat(E, "_list"),
      className: "".concat(g, "-empty"),
      onMouseDown: B
    }, oe);
  var me = Object.keys(U).map(function(t) {
    return U[t];
  }), q = function(e) {
    return e.label;
  };
  function G(t, e) {
    var r = t.group;
    return {
      role: r ? "presentation" : "option",
      id: "".concat(E, "_list_").concat(e)
    };
  }
  var T = function(e) {
    var r = f[e];
    if (!r)
      return null;
    var a = r.data || {}, o = a.value, n = r.group, l = Z(a, !0), m = q(r);
    return r ? /* @__PURE__ */ i.createElement("div", K({
      "aria-label": typeof m == "string" && !n ? m : null
    }, l, {
      key: e
    }, G(r, e), {
      "aria-selected": j(o)
    }), o) : null;
  }, J = {
    role: "listbox",
    id: "".concat(E, "_list")
  };
  return /* @__PURE__ */ i.createElement(i.Fragment, null, N && /* @__PURE__ */ i.createElement("div", K({}, J, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), T(d - 1), T(d), T(d + 1)), /* @__PURE__ */ i.createElement(Ee, {
    itemKey: "key",
    ref: P,
    data: f,
    height: se,
    itemHeight: ce,
    fullHeight: !1,
    onMouseDown: B,
    onScroll: ne,
    virtual: N,
    direction: le,
    innerProps: N ? null : J
  }, function(t, e) {
    var r, a = t.group, o = t.groupOption, n = t.data, l = t.label, m = t.value, V = n.key;
    if (a) {
      var D, de = (D = n.title) !== null && D !== void 0 ? D : ee(l) ? l.toString() : void 0;
      return /* @__PURE__ */ i.createElement("div", {
        className: Y(g, "".concat(g, "-group")),
        title: de
      }, l !== void 0 ? l : V);
    }
    var I = n.disabled, Q = n.title;
    n.children;
    var ve = n.style, pe = n.className, ge = Pe(n, Te), ye = Ce(ge, me), y = j(m), b = "".concat(g, "-option"), be = Y(g, b, pe, (r = {}, w(r, "".concat(b, "-grouped"), o), w(r, "".concat(b, "-active"), d === e && !I), w(r, "".concat(b, "-disabled"), I), w(r, "".concat(b, "-selected"), y), r)), _ = q(t), he = !h || typeof h == "function" || y, M = typeof _ == "number" ? _ : _ || m, X = ee(M) ? M.toString() : void 0;
    return Q !== void 0 && (X = Q), /* @__PURE__ */ i.createElement("div", K({}, Z(ye), N ? {} : G(t, e), {
      "aria-selected": y,
      className: be,
      title: X,
      onMouseMove: function() {
        d === e || I || S(e);
      },
      onClick: function() {
        I || L(m);
      },
      style: ve
    }), /* @__PURE__ */ i.createElement("div", {
      className: "".concat(b, "-content")
    }, M), /* @__PURE__ */ i.isValidElement(h) || y, he && /* @__PURE__ */ i.createElement(ke, {
      className: "".concat(g, "-option-state"),
      customizeIcon: h,
      customizeIconProps: {
        isSelected: y
      }
    }, y ? "✓" : null));
  }));
}, De = /* @__PURE__ */ i.forwardRef(Ve);
De.displayName = "OptionList";
export {
  De as default
};
//# sourceMappingURL=OptionList.mjs.map
